export type SelectorRules = {
  required: string;
};

export const getRules = (
  selectAllAvailable: boolean,
  selectorLabel: string,
): SelectorRules | undefined => {
  if (selectAllAvailable) {
    return undefined;
  }

  return { required: `Select ${selectorLabel} is required` };
};
